import React from "react";

const LeadSummary = (props) => {
    const {leadinfo} = props;
    const {leadstotal} = props;
    return(
        <div className="summary-blocks">
            <h2>Leads</h2>
            <div className="record-details">
                <ul className="colored-record">
                    <li className="row-1">
                        <div className="row-data">{leadstotal}</div>
                        <div className="data-percent"></div>
                        <div className="data-label">Total</div>
                    </li>
                    <li className="row-2">
                        <div className="row-data">{leadinfo?.won?.count}</div>
                        <div className="data-percent">{leadinfo?.won?.percentage}%</div>
                        <div className="data-label">Won</div>
                    </li>
                    <li className="row-3">
                        <div className="row-data">{leadinfo?.lost?.count}</div>
                        <div className="data-percent">{leadinfo?.lost?.percentage}%</div>
                        <div className="data-label">Lost</div>
                    </li>
                    <li className="row-4">
                        <div className="row-data">{leadinfo?.open?.count}</div>
                        <div className="data-percent">{leadinfo?.open?.percentage}%</div>
                        <div className="data-label">Open</div>
                    </li>
                    <li className="row-5">
                        <div className="row-data">{leadinfo?.ignore?.count}</div>
                        <div className="data-percent">{leadinfo?.ignore?.percentage}%</div>
                        <div className="data-label">Ignored</div>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default LeadSummary;